/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Jagrati Panchal",
  title: "Hi all, I'm Jagrati",
  subTitle: emoji(
    "A Full Stack Developer who is Dedicated and honest with her  work and believes in hardwork.Love to accept challenges and work on them with full dedication which leads to strong in skills more and having experiences in collaborative  projects with good team communication."
  ),
  resumeLink: require("./assets/images/resume.png"),
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/JagratiPanchal",
  linkedin: "https://www.linkedin.com/in/jagrati-panchal-6a9a56206/",
  gmail: "https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=VpCqJVDnqBnZDcjqQvfWRppvgGMKvGmncDhGkdqQlfghMrrfKgdjpPtQHlvHcNjsfJgLXDQ",
  medium: "https://jagratipanchal.medium.com/",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "SKILLS",
  skills: [
    emoji(
      "I Develop highly interactive Front end / User Interfaces for the web and mobile applications using CSS,Javascript,React Libraries,Framework,HTML."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML",
      fontAwesomeClassname: "fab fa-html5",
      image:"https://www.gauravtambe.com/static/media/html5svg.4e771a85.svg"
     
    },
    {
      skillName: "Git Hub",
      fontAwesomeClassname: "fab fa-github",
      image:"https://www.gauravtambe.com/static/media/githubsvg.597ca118.svg"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt",
      image:"https://www.gauravtambe.com/static/media/css3svg.7d0accfc.svg"
     
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
      image:"https://www.gauravtambe.com/static/media/jssvg.db8773c5.svg"
     
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react",
      image:"https://www.gauravtambe.com/static/media/reactsvg.31408b31.svg"
     
    },
    {
      skillName: "Material Ui",
      fontAwesomeClassname: "fab fa-node",
      image:"https://www.gauravtambe.com/static/media/materialuipng.5b2d8a0a.png"
     
    },
    {
      skillName: "Styled Components",
      fontAwesomeClassname: "fab fa-node",
      image:"https://www.gauravtambe.com/static/media/styledComponentsPng.67fab711.png"
     
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Masai School",
      logo:"https://images.yourstory.com/cs/images/companies/Masai-1597756802133.jpg?fm=png&auto=formatar=1:1&mode=fill&fill=solid",
      subHeader: "Full Stack Web Development (Full time)",
      duration: "January 2021 - August 2021",
      desc: "Completed 6 month training of Full Stack Web Development at Masai School",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "S.K. GOVT SCIENCE COLLEGE, SIKAR",
      logo: "https://i0.wp.com/sarvjanakari.com/wp-content/uploads/2020/12/Shri-Kalyan-Govt.-Medical-College-Sikar-Rajasthan.jpg?fit=720%2C480&ssl=1",
      subHeader: "Bachelor of Science in Mathematics.",
      duration: "September 2013 - April 2017",
      desc: "Secured First Grade",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "MY SOME COLLABORATIVE PROJECTS,WHICH I CLONED DURING MY MASAI JOURNEY OF SIX MONTH. ",
  projects: [
    {
      poster:"urban.png",
     
      image: require("./assets/images/urban.png"),
      projectName: "URBAN CLAP",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      intro: "A Company that allows skilled and proffessionals to connect with users who are looking for services",
      tech: ["React.js", "Javascript", "Firebase", "HTML", "CSS","React Library"],
      time: "Completed within two weeks.",
      type: "Collaborative project with team of 3 members.",
      role: ["Built service pages.", "Carousel Features Added using React Library", "Implemented logic for navigations and built UI for this."],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://urban-company-clone.netlify.app/"
        },

        {
          name: "Git Hub",
          url: "https://github.com/AleemAlam/Urban-Company"
        }
        //  you can add extra buttons here.
      ]
    },

    {
      poster:"goibibo.png",
      image: require("./assets/images/goibibo.png"),
      projectName: "Goibibo.com",
      intro: "Goibibo is India’s leading online travel booking brand providing range of choice for hotels, flights, trains, bus and cars for travelers. ",
      tech: ["React.js", "Javascript", "Firebase", "HTML", "CSS","Redux","React Library"],
      time: "Completed within 5 days.",
      type: "Collaborative project with team of 4 members.",
      role: ["Built Bus Section and Travel Details part","Frontened for Landing Page and Travel Details Page","Swape feature for input values"],
      footerLink: [
        {
          name: "Visit Website",
          url: " https://goibibo-project-dff906.netlify.app/"
        },

        {
          name: "Git Hub",
          url: "https://github.com/Dee-Hegde/goibibo_clone"
        }
        //  you can add extra buttons here.
      ]
    },

    {
      image: require("./assets/images/engage.PNG"),
      projectName: "EngageBay",
      intro: "EngageBay is an affordable all-in-one CRM with marketing, sales & support solution for growing businesses to engage and convert web visitors to happy.",
      tech: ["JavaScript","HTML", "CSS"],
      time: "Completed within 3 days.",
      type: "My First Collaborative project with team of 3 members.",
      role: ["Built UI for Login and Sign up page and  Responsive Mobile view part."],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.engagebay.com/"
        },

        {
          name: "Git Hub",
          url: "https://github.com/Darshan-Naik/Project_1_engage"
        }
        //  you can add extra buttons here.
      ]
    }
    // {
    //   image: require("./assets/images/nextuLogo.webp"),
    //   projectName: "URBAN CLAP",
    //   projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //   intro: "Goibibo is India’s leading online travel booking brand providing range of choice for hotels, flights, trains, bus and cars for travelers. ",
    //   tech: ["React.js", "Javascript", "Firebase", "HTML", "CSS"],
    //   time: "Completed within two weeks.",
    //   type: "Collaborative project with team of 3 members.",
    //   role: ["Built service pages.", "Carousel Features Added using React Library", "Implemented logic for navigations and built UI for this."],
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://nextu.se/"
    //     },
    //     {
    //       name: "Git Hub",
    //       url: "http://saayahealth.com/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",

  blogs: [
    {
      url: "https://jagratipanchal.medium.com/",
      title: "EngageBay- My First Project",
      description:
        "A Girl,Student of Masai School,Who Even Didn’t Know How To Do E-Mail Someone, Has Made The Clone of Login And Signup Page Of EngageBay Website In just 3 Days…"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Contact Me Here 💁",
  number: "9460986008",
  email_address: "panchaljagrati1997@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
